import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * return component
 * @param {*} props
 */
const ShowSubKeys = (props) => {
  const {
    filledFormData,
    searchKeys,
    preFilledWith,
    isPreFilled,
  } = props;
  const [showData, setShowData] = useState({});
  let formValues = {};

  useEffect(() => {
    if (isPreFilled && preFilledWith === 'filledFormData') {
      /* eslint-disable no-restricted-syntax -- need */
      for (const key in filledFormData) {
        if (key.includes(searchKeys[0])) {
          const keySuffix = key.split('-');
          const keyVal = filledFormData[`${searchKeys[1]}-${keySuffix[1]}`];
          formValues = {
            ...formValues,
            [filledFormData[key]]: keyVal,
          };
        }
      }
      /* eslint-enable no-restricted-syntax -- need */
      setShowData({ ...showData, ...formValues });
    }
  }, []);

  return (
    <>
      {
        Object.entries(showData).map(([key]) => (
          <div className="row" key={key}>
            {key}{'  '}{showData[key]}
          </div>
        ))
      }
    </>
  );
};

ShowSubKeys.propTypes = {
  preFilledWith: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  isPreFilled: PropTypes.string,
  searchKeys: PropTypes.objectOf(PropTypes.shape),
};

export default ShowSubKeys;
